import React from 'react';
import { motion } from 'framer-motion';
import { Award, Rocket, Users } from 'lucide-react';

const features = [
  {
    icon: Award,
    title: 'Excellence in Execution',
    description: 'A relentless focus on quality and impact, delivering solutions that exceed expectations.'
  },
  {
    icon: Rocket,
    title: 'Future-Ready Innovation',
    description: 'Cutting-edge solutions that keep businesses ahead in the rapidly evolving digital landscape.'
  },
  {
    icon: Users,
    title: 'Customer-Centric Approach',
    description: 'Tailored strategies that prioritize user experience and drive meaningful business outcomes.'
  }
];

const WhyChooseUs = () => {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl md:text-4xl font-display font-semibold text-gray-900 mb-4"
          >
            Why Choose Solutions21?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-xl text-gray-600"
          >
            We don't just build technology; we create transformative digital experiences that drive growth, efficiency, and innovation.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                className="relative p-8 rounded-xl bg-gradient-to-br from-gray-800 to-gray-700 backdrop-blur-sm border border-gray-600 hover:border-gray-500 transition-all duration-300 group"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-accent/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl" />
                <div className="relative">
                  <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-accent" />
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-300">
                    {feature.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;